<template>
  <div class="text-start">
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <div>Home</div>
            <span class="mx-2">/</span>
            <span>{{ user.name || 'My' }} profile</span>
          </div>
          <div class="text-xl">
            {{ user.name || 'My' }} Profile
          </div>
        </div>
      </div> 
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class=" overflow-auto">
        <div class="md:flex block ">
          <div class="rounded rounded-t-lg overflow-hidden shadow md:max-w-xs mb-3">
            <img src="https://www.brookes.ac.uk/assets/0/2147493288/2147493291/70860e98-194e-4aed-bafe-d57cfe3c45b5.jpg"
                 class="w-full"/>
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ user.name || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">{{ user.phone_number || 'My' }}</p>
              <p class=" font-sans font-light text-grey-dark">{{ user.email || 'My' }}</p>
            </div>
            <div class="flex justify-center pb-3 text-grey-dark hidden">
              <div class="text-center mr-3 border-r pr-3">
                <h2>34</h2>
                <span>Connections</span>
              </div>
              <div class="text-center">
                <h2>42</h2>
                <span>Organizations</span>
              </div>
            </div>

            <ul class="mt-5">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'profile', params: {path: 'connections'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="activity" size="16" class="mr-4"></feather>
                  Connections
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'profile', params: {path:'account'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="credit-card" size="16" class="mr-4"></feather>
                  Billing
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'profile', params: {path:'account'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="user" size="16" class="mr-4"></feather>
                  My Account
                </router-link>
              </li>

              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'profile', params: {path: 'reset_password'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="shield" size="16" class="mr-4"></feather>
                  Reset Password
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 hidden">
                <router-link :to="{name:'profile', params: {path:'settings'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="sliders" size="16" class="mr-4"></feather>
                  Settings
                </router-link>
              </li>
            </ul>
          </div>
          <div class="w-full mt-3 md:mt-0 md:ml-4">
            <ResetPassword v-if="path === 'reset_password'"/>
            <Account v-else/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from "../profile/ResetPassword";
import Account from "./Account";

export default {
  name: "ProfileComponent",
  components: {Account, ResetPassword,},
  props: {
    userId: String,
    path: String
  },
  data() {
    return {
      user: Object,
    }
  },
  mounted() {
    this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/user')
        .then((result) => {
          this.user = result.data.data;
        })
        .catch((error) => {
          if (error.response.status === 401)
            this.$router.push("/logout");
        });
  }
}
</script>

<style scoped>

</style>